import React from "react";
import { Route } from "react-router-dom";
import Academics from "../pages/Academics";
import ProgramDetails from "../page_content/academics_section/programs_offered/ProgramDetails";
import ProgramOfferd from "../page_content/academics_section/programs_offered/ProgramsOffered";
import ShipInCampus from "../page_content/academics_section/ship_in_campus/ShipInCampus";
import Syllabus from "../page_content/academics_section/syllabus/Syllabus";
import AcademicCalendar from "../page_content/academics_section/academic_calendar/AcademicCalendar";
import OfficerLikeQualities from "../page_content/academics_section/officer_like_qualities/OfficerLikeQualities";
import FacultyInfo from "../page_content/academics_section/faculty_info/FacultyInfo";
import FacultyResearch from "../page_content/academics_section/faculty_research/FacultyResearch";
import Achievements from "../page_content/academics_section/achievements/Achievements";
import FeedbackReport from "../page_content/academics_section/FeedbackReport";

export const AcademicsRoutes = (
  <Route path="academics" element={<Academics />}>
    <Route path=":programId" element={<ProgramDetails />} />
    <Route path="programs-offered" element={<ProgramOfferd />} />
    <Route path="ship-in-campus" element={<ShipInCampus />} />
    <Route path="syllabus" element={<Syllabus />} />
    <Route path="academic-calendar" element={<AcademicCalendar />} />
    <Route path="officer-qualities" element={<OfficerLikeQualities />} />
    <Route path="faculty-info" element={<FacultyInfo />} />
    <Route path="faculty-research" element={<FacultyResearch />} />
    <Route path="achievements" element={<Achievements />} />
    <Route path="feedback-report" element={<FeedbackReport />} />
  </Route>
);
